(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  // Footer collapsible functionality - Improved version
  document.addEventListener('DOMContentLoaded', function() {
    const collapsibleButtons = document.querySelectorAll('.footer-block__heading--mobile-collapsible');

    collapsibleButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        // Find the content div - it's after both the button and the h2 heading
        let content = this.nextElementSibling;

        // Skip the h2 heading if it exists
        if (content && content.classList.contains('footer-block__heading')) {
          content = content.nextElementSibling;
        }

        // Ensure we found the content wrapper
        if (!content || !content.classList.contains('footer-block__collapsible-content--mobile')) {
          console.warn('Footer collapsible content not found');
          return;
        }

        // Toggle state
        this.setAttribute('aria-expanded', !isExpanded);

        // Smooth toggle with proper height calculation
        if (!isExpanded) {
          // Opening
          content.style.maxHeight = content.scrollHeight + 'px';
          content.classList.add('active');

          // After animation, set to auto for dynamic content
          setTimeout(() => {
            if (content.classList.contains('active')) {
              content.style.maxHeight = 'none';
            }
          }, 300);
        } else {
          // Closing - first set explicit height
          content.style.maxHeight = content.scrollHeight + 'px';

          // Force reflow
          content.offsetHeight;

          // Then animate to 0
          requestAnimationFrame(() => {
            content.style.maxHeight = '0';
            content.classList.remove('active');
          });
        }
      });
    });

    // Handle window resize for open collapsibles
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.querySelectorAll('.footer-block__collapsible-content--mobile.active').forEach(content => {
          if (content.style.maxHeight !== '0px') {
            content.style.maxHeight = 'none';
          }
        });
      }, 250);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Calculate and set header height
  function setHeaderHeight() {
    const header = document.querySelector('.header-wrapper');
    if (header) {
      const headerHeight = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    }
  }
  
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('scroll', setHeaderHeight);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.removeAttribute('data-reserve-space');
              
              // CRITICAL: Initialize SliderComponent after AJAX load
              const sliderComponent = this.querySelector('slider-component');
              if (sliderComponent && typeof SliderComponent !== 'undefined') {
                // Manually trigger the slider initialization
                const slider = sliderComponent.querySelector('[id^="Slider-"]');
                const prevButton = sliderComponent.querySelector('button[name="previous"]');
                const nextButton = sliderComponent.querySelector('button[name="next"]');
                
                if (slider && prevButton && nextButton) {
                  // Re-create the SliderComponent instance
                  const newSlider = new SliderComponent();
                  newSlider.slider = slider;
                  newSlider.sliderItems = sliderComponent.querySelectorAll('[id^="Slide-"]');
                  newSlider.prevButton = prevButton;
                  newSlider.nextButton = nextButton;
                  newSlider.prevButtonArrow = sliderComponent.querySelector('button.slider-arrow[name="previous"]');
                  newSlider.nextButtonArrow = sliderComponent.querySelector('button.slider-arrow[name="next"]');
                  
                  newSlider.initPages();
                  
                  const resizeObserver = new ResizeObserver(entries => newSlider.initPages());
                  resizeObserver.observe(slider);
                  
                  slider.addEventListener('scroll', newSlider.update.bind(newSlider));
                  
                  if (newSlider.nextButtonArrow && newSlider.prevButtonArrow) {
                    newSlider.prevButtonArrow.addEventListener('click', newSlider.onButtonClick.bind(newSlider));
                    newSlider.nextButtonArrow.addEventListener('click', newSlider.onButtonClick.bind(newSlider));
                  }
                }
              }
            } else {
              this.removeAttribute('data-reserve-space');
            }
          })
          .catch(e => {
            this.removeAttribute('data-reserve-space');
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
